import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { closeSnackbar, openDefaultErrorSnackbar } from 'store/reducers/snackbar';

const blacklistedEndPoints = ['verifyPassword', 'changePassword'];

export const rtkQueryErrorHandler: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action) && !blacklistedEndPoints.includes(action.meta.arg.endpointName)) {
    const message = 'data' in action.payload ? (action.payload.data as { errorMessage: string }).errorMessage : action.payload.message;
    if (typeof action?.payload?.data === 'string' && action.payload.data.includes('Upload canceled')) {
      return;
    }
    api.dispatch(
      openDefaultErrorSnackbar({
        message
      })
    );
  } else if (action?.type === 'auth/updateToken') {
    api.dispatch(closeSnackbar());
  }
  return next(action);
};
